import RouteView from "../../../Routes/RouteView"
import OpEnNavOption, {defaultRoute} from "./OpEnNavOption"
const OpEnterprise = ({navoption, ModalAction}) => {
  return (
        <RouteView navoption={navoption} ModalAction={ModalAction} defaultRoute={defaultRoute}>{OpEnNavOption}</RouteView>
  )
}

export default OpEnterprise
